import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import {
  Cancel,
  Check,
  HourglassEmpty,
  HourglassFull,
  Warning,
} from '@mui/icons-material';

export default function DeploymentStateIndicator({ state }) {
  let icon = (
    <span className="text-warning">
      <HourglassFull />
    </span>
  );
  if (state === 'BUILDING') {
    icon = (
      <span className="text-warning">
        <HourglassEmpty />
      </span>
    );
  }
  if (state === 'ERROR') {
    icon = (
      <span className="text-danger">
        <Cancel />
      </span>
    );
  }
  if (state === 'READY') {
    icon = (
      <span className="text-success">
        <Check />
      </span>
    );
  }
  if (state === 'Plan expired') {
    icon = (
      <span className="text-danger">
        <Warning />
      </span>
    );
  }

  //   Possible values are BUILDING, READY, or ERROR

  return (
    <div className="mr-2" style={{ width: 30 }}>
      {state && (
        <Tooltip title={state}>
          <IconButton size="small" aria-label="Deployment state">
            {icon}
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
}
